// extracted by mini-css-extract-plugin
export var addToCartButton = "_qd-b";
export var arrowButtonContainer = "_qd-9";
export var arrowButtonIcon = "_qd-a";
export var carouselArrowButton = "_qd-6";
export var carouselElementContainer = "_qd-1";
export var left = "_qd-7";
export var productDisplayCarouselContainer = "_qd-0";
export var productTileContainer = "_qd-2";
export var productTileImage = "_qd-4";
export var productTileImageContainer = "_qd-3";
export var productTileTitle = "_qd-5";
export var right = "_qd-8";
export var sliderOverflow = "_qd-c";